import { IState } from '../../store';

export function selectTrackingPage(state: IState) {
  return state.tracking.page;
}
